import * as THEOPlayer from '@theoplayer/basic-hls-dash'
import { ref, computed } from '@vue/composition-api'

const useClipperPlayer = () => {
  const player = ref<THEOPlayer.Player|null>(null)
  const isPlaying = ref(false)
  const isMuted = ref(false)
  const videoDuration = computed(() => player.value?.duration || 0)
  const currentTime = ref(0)

  const setupPlayer = (newPlayer: THEOPlayer.Player) => {
    player.value = newPlayer
    isPlaying.value = newPlayer.paused
    isMuted.value = newPlayer.muted
  }

  const destroyPlayer = () => {
    player.value?.destroy()
    player.value = null
  }

  const jumpToSeek = (seek: number) => {
    if (player.value === null) return
    player.value.currentTime = seek
  }

  const jumpFrame = (direction: string) => {
    const seek = direction === 'forward' ? currentTime.value + 15 : currentTime.value - 15
    if (seek < 0 || seek > videoDuration.value) return
    jumpToSeek(seek)
  }

  const toggleMute = () => {
    if (player.value === null) return
    player.value.muted = !player.value.muted
    isMuted.value = !isMuted.value
  }

  const togglePlay = () => {
    if (player.value === null) return
    if (isPlaying.value) {
      player.value.pause()
    } else {
      player.value.play()
    }
    isPlaying.value = !isPlaying.value
  }

  return {
    currentTime,
    destroyPlayer,
    isPlaying,
    isMuted,
    jumpToSeek,
    jumpFrame,
    setupPlayer,
    toggleMute,
    togglePlay,
    videoDuration
  }
}

export default useClipperPlayer
